import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Divider, Grid, Typography } from '@material-ui/core/';
import NotificationImportant from '@material-ui/icons/NotificationImportant';
import classNames from 'classnames';
import { getUserNotification } from '~/store/legacy/actions/userActions';
import useStyles from './DinerNotice.style.js';
import { selectUserNotifications } from '~/store/legacy/selector/userSelectors';

const isValidNotification = (notification) => {
  const now = Date.now();
  const { type } = notification;
  const { start_at, end_at } = notification.attributes;
  return type === 'diner_notice' && now > new Date(start_at) && now < new Date(end_at);
};

const DinerNotice = ({ addressId, geoLocation, className, style }) => {
  const [dispatch, classes] = [useDispatch(), useStyles()];
  const { notifications, notificationsLoaded } = useSelector(selectUserNotifications);
  useEffect(() => {
    if ((addressId || geoLocation) && !notificationsLoaded) {
      dispatch(getUserNotification({ addressId, geoLocation }));
    }
  }, [addressId, geoLocation]);
  if (!notificationsLoaded) {
    return null;
  }
  const validNotifications = notifications && notifications.filter(isValidNotification);
  if (validNotifications && validNotifications.length > 0) {
    return (
      <Grid
        container
        direction='column'
        className={classNames(classes.notification, className)}
        style={style}>
        <Grid container alignItems='center'>
          <Typography variant='subtitle2'>
            <b>Notifications</b>
          </Typography>
          <NotificationImportant classes={{ root: classes.notificationIcon }} />
        </Grid>
        <Divider />
        {validNotifications.map((notification) => {
          const { message } = notification.attributes;
          return (
            <Grid container key={notification.id}>
              <Grid item xs={12}>
                <Typography variant='body1'>{message}</Typography>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    );
  }
  return null;
};

export default DinerNotice;
